import { Component, OnInit } from '@angular/core';
import { AppService }  from '../../services/app.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
	randomGif : string;

	constructor(
		public appService: AppService
	) { 
	
	}

	ngOnInit(): void {
		this.appService.setDefaultAuthor();
	  	this.appService.navActive();
		this.selectRandomGif();
		
		this.appService.setPageTitle('Pagina niet gevonden');
		this.appService.setPageDescription('');
	}

	giphy: Array<string> = ["https://media.giphy.com/media/NfOD0Bv11XnhK/giphy.gif",
	"https://media.giphy.com/media/OPU6wzx8JrHna/giphy.gif",
	"https://media.giphy.com/media/ISOckXUybVfQ4/giphy.gif",
	"https://media.giphy.com/media/LZQsVAzgB6sE0/giphy.gif",
	"https://media.giphy.com/media/nrXif9YExO9EI/giphy.gif",
	"https://media.giphy.com/media/TPl5N4Ci49ZQY/giphy.gif",
	"https://media.giphy.com/media/13Cmju3maIjStW/giphy.gif",
	"https://media.giphy.com/media/rjN9e4I4mgspy/giphy.gif",
	"https://media.giphy.com/media/HlqvH9JrahLZ6/giphy.gif",
	"https://media.giphy.com/media/3ohuPFcrDZIO8LKQKc/giphy.gif",
	"https://media.giphy.com/media/BbBYfhduY1u3m/giphy.gif",];

	 selectRandomGif () {
	
	this.randomGif = this.giphy[Math.floor(Math.random() * this.giphy.length)]
	}


}
